import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import eventService from "services/eventService";

export const getEvents = createAsyncThunk(
	"vino/deliveryMethods/list",
	async (params, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const events = await eventService.list();
			return events;
		} catch (err) {
			dispatch(
				showMessage({
					message: "Error occurred while getting events",
					variant: "error",
				})
			);
			return rejectWithValue(err.response.data);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const eventsSlice = createSlice({
	name: "vino/events",
	initialState: {
		list: [],
	},
	reducers: {},
	extraReducers: {
		[getEvents.fulfilled]: (state, action) => {
			state.list = action.payload;
		},
	},
});

export default eventsSlice.reducer;
